export const MAX_ADVANCEMENT_ORIGIN_LINES = 512;

export const actionLineArrayFits = (value, { allowEmpty = false } = {}) =>
  Array.isArray(value) &&
  (allowEmpty || value.length > 0) &&
  value.length <= MAX_ADVANCEMENT_ORIGIN_LINES;
